import { useState } from 'react';

import { CellContext } from 'core/Hooks';
import { Table } from 'core/Packages';
import { IconEdit, IconX } from 'ui/Icons';

import { useShowCurrentCampaign } from '../../../../../../api/new/campaigns/get';
import { usePeerName } from '../../../hooks/usePeerName';
import { AddEditPeerModal } from './AddEditPeerModal';
import { RemovePeerModal } from './RemovePeerModal';
import { PeerTableType } from './peers.types';

export const PeerActions = (props: CellContext<PeerTableType, unknown>) => {
  const { peerName } = usePeerName();
  const { data: campaign } = useShowCurrentCampaign();
  const [isOpened, setIsOpened] = useState<'edit' | 'delete'>();

  if (campaign?.status === 'finished' || campaign?.status === 'finishing_required') return null;

  return (
    <>
      <Table.RowAction>
        <Table.RowAction.Option
          label={`Edit ${peerName.singular} info`}
          icon={IconEdit}
          onClick={() => setIsOpened('edit')}
        />
        <Table.RowAction.Option
          label={`Remove ${peerName.singular}`}
          icon={IconX}
          onClick={() => setIsOpened('delete')}
          destructive
        />
      </Table.RowAction>
      <AddEditPeerModal
        opened={isOpened === 'edit'}
        onClose={() => setIsOpened(undefined)}
        uuid={props.row.original.uuid}
      />
      <RemovePeerModal
        uuid={props.row.original.uuid}
        name={props.row.original.name}
        opened={isOpened === 'delete'}
        onClose={() => setIsOpened(undefined)}
      />
    </>
  );
};
